// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'reset-css';
import xvueui from 'xvue-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Es6Promise from 'es6-promise';
Es6Promise.polyfill()

Vue.use(xvueui)
Vue.use(VueAwesomeSwiper, /* { default global options } */ )
Vue.config.productionTip = false

//building
Vue.prototype.$isbuild = function() {
    this.$Message.info({
        content: "敬请期待"
    })
    return false
}

//跳转
Vue.prototype.$toweb = function(url) {
    window.open(url)
}

//设备判断
Vue.prototype.$isMobile = function() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js